import { render } from "./FormApproval.vue?vue&type=template&id=b2933b10&scoped=true"
import script from "./FormApproval.vue?vue&type=script&lang=js"
export * from "./FormApproval.vue?vue&type=script&lang=js"

import "./FormApproval.vue?vue&type=style&index=0&id=b2933b10&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\sport.yanhuotiyu.com焱火pc端web网站\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2933b10"]])

export default __exports__